/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentStatusEnum } from './document-status-enum';

export interface DeckSelfPublishFile {
  readonly id: string;
  readonly file: string | null;
  readonly name: string | null;
  readonly type: string;
  readonly description: string | null;
  readonly status: DocumentStatusEnum;
  readonly type_name: string | null;
  readonly rejection_reason: string | null;
}
export namespace DeckSelfPublishFile {}
